import React, { useEffect, useState } from 'react';
import {ItemsStorageService} from "./filtering/itemsStorageService";
import {filtersManager} from "./filtering/filtersManager";

interface OpenFilterButtonIconProps {
    itemsStorageService: ItemsStorageService,
}

const OpenFilterButtonIcon = ({ itemsStorageService }: OpenFilterButtonIconProps) => {
    const [filtersCount, setFiltersCount] = useState(0);

    const changeFiltersCount = () => {
        setFiltersCount(itemsStorageService.getCurrentFilters().length);
    };

    useEffect(() => {
        filtersManager.registerFiltersChangingObserver(changeFiltersCount);
        setFiltersCount(itemsStorageService.getCurrentFilters().length);
        return () => filtersManager.registerFiltersChangingObserver(changeFiltersCount);
    }, []);

    return (
        filtersCount > 0 ? <p className="block__bullet filter__count">{filtersCount}</p> : null
    );
};

export default OpenFilterButtonIcon;
